import {createContext, useContext, useState} from "react";
import {Alert, Snackbar} from "@mui/material";

const NotificationContext = createContext()

const NotificationProvider = ({children}) => {
    const defaultNotification = {
        open: false,
        message: '',
        type: 'info'
    }

    const [notification, setNotification] = useState(defaultNotification);

    const showNotification = (notification) => {
        setNotification({
            ...defaultNotification,
            ...notification
        })
    }

    return <>
        <Snackbar
            open={notification.open}
            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
            autoHideDuration={3500}
            onClose={() => setNotification({...defaultNotification})}>
            <Alert
                severity={notification.type}
                variant='filled'
                sx={{width: '100%'}}
            >
                {notification.message}
            </Alert>
        </Snackbar>
        <NotificationContext.Provider value={{ showNotification }}>{children}</NotificationContext.Provider>
    </>
};

export default NotificationProvider;

export const useNotification = () => useContext(NotificationContext);